/** WSRAPI-0073 — seeded, editable, and read by nothing. `lastSales` takes its page size
 *  from code because the safe range depends on the outbound buffer. No replacement is
 *  coming. Full keys only: six live siblings differ by prefix alone. */
export const RETIRED_KEYS: ReadonlySet<string> = new Set([
  'WStudio.sales.listSales.max',
  'WStudio.sales.listSales.offset',
]);
